import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("canvas", { id: "canvas" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "qrCode" }, null, -1)

import QRCode from "qrcode";
import {useRoute} from "vue-router";
import * as timers from "timers";
import {onMounted, reactive, UnwrapRef} from "vue";
import {getSaleOrder, getSaleOrderQrCode, getSaleOrderWxPayStatus} from "@/api/sale_order";
import {finishTask} from "@/api/home";
import {message} from "ant-design-vue";
import router from "@/router";
interface Data {
  amount: number | undefined
}

export default /*#__PURE__*/_defineComponent({
  __name: 't34',
  setup(__props) {


const route = useRoute();

const data: UnwrapRef<Data> = reactive({
  amount:0.00
})

let timerId:any = null;

const getQrCode = () => {
  const saleOrderId = route.query.saleOrderId;
  getSaleOrderQrCode(saleOrderId).then((res: any) => {
    console.log(res)
    let canvas = document.getElementById("canvas");
    QRCode.toCanvas(canvas, res.qrCode, function (error) {
      if (error) console.error(error)
      console.log('success!');
      timerId = timers.setInterval(getWxPayStatus, 3000, res.saleOrderId);
    })
  })
}
const getSaleOrderById = () => {
  const saleOrderId = route.query.saleOrderId;
  getSaleOrder(saleOrderId).then((res: any) => {
    console.log(res)
    data.amount = res.amount
  })
}

const getWxPayStatus = (saleOrderId: any) => {
    getSaleOrderWxPayStatus(saleOrderId).then((res: any) => {
      console.log(res.success);
      if (res.success) {
        timers.clearInterval(timerId);
        finishTask34(saleOrderId)
      }
    })
}


const finishTask34 = (saleOrderId: any) => {
  let processDefinitionId = route.query.processDefinitionId;
  let processInstanceId = route.query.processInstanceId;
  let processDefinitionKey = route.query.processDefinitionKey;
  let runTimeTaskId = route.query.runTimeTaskId;
  let taskCode = route.query.taskCode

  let parameters = {
    processDefinitionId: processDefinitionId,
    processInstanceId: processInstanceId,
    processDefinitionKey: processDefinitionKey,
    runTimeTaskId: runTimeTaskId,
    taskCode: taskCode,
    params: {saleOrderId: saleOrderId}
  };
  finishTask(parameters).then(() => {
    message.success("操作成功");
    router.push({
      path: "/home",
    });
  });
}

onMounted(() => {
  getSaleOrderById();
  getQrCode()
})


return (_ctx: any,_cache: any) => {
  const _component_pay_circle_outlined = _resolveComponent("pay-circle-outlined")!
  const _component_a_statistic = _resolveComponent("a-statistic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_statistic, {
      title: "您需要支付:",
      value: data.amount,
      precision: 2,
      suffix: "元",
      "value-style": { color: '#3f8600' },
      style: {"margin-right":"50px"}
    }, {
      prefix: _withCtx(() => [
        _createVNode(_component_pay_circle_outlined)
      ]),
      _: 1
    }, 8, ["value"]),
    _hoisted_2,
    _hoisted_3
  ]))
}
}

})